import { lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import Users from '../pages/users/Users'
import CompanyTabs from '../pages/company/CompanyTabs'
import { SupportWrapper } from '../pages/support/SupportWrapper'

import StoreScreen from '../pages/stores/StoreScreen'
import VoucherScreen from '../pages/management/VoucherScreen'
import InvestigationScreen from '../pages/investigation/InvestigationScreen'

import ListScreen from '../pages/lists/ListScreen'
import BUScreen from '../pages/lists/bu/BUScreen'
import RegionalScreen from '../pages/lists/regional/RegionalScreen'
import TamanhoScreen from '../pages/lists/tamanho/TamanhoScreen'
import PriceScreen from '../pages/lists/prices/PriceScreen'

import ReportPositivacao from '../pages/reports/positivacao/ReportPositivacao'
import ReportAtivacao from '../pages/reports/ativacao/ReportAtivacao'
import ReportLojistas from '../pages/reports/lojistas/ReportLojistas'
import ReportCupons from '../pages/reports/cupons/ReportCupons'
import ReportApuracao from '../pages/reports/apuracao/ReportApuracao'
import LogsScreen from '../pages/logs/LogsScreen'
import APIManageUsers from '../pages/api/manage-users/APIManageUsers'
import APIManageServices from '../pages/api/pages/QueryManager'
import AIScreen from '../pages/ai/AIScreen'
import AlertScreen from '../pages/alerts/AlertScreen'
import PermissionsScreen from '../pages/permissions/PermissionsScreen'
import SettingsScreen from '../pages/settings/'
import HomePage from '../pages/home/HomePage'

import ValidacaoPromoCupom from '../pages/validacoes/promo_cupom'
import ValidacaoComparacaoBeneficioValor from '../pages/validacoes/comparacao_beneficio_valor'

import NPSList from '../pages/nps/NPSList'
import NPSCreator from '../pages/nps/NPSCreator'

import CampaignHistory from '../pages/campaign-simulator/components/CampaignHistory'

import ConectaReport from '../pages/conecta/reports/'
import DataTransferDefaultScreen from '../pages/datatransfer/default'

import SellerMapping from '../pages/seller-mapping/pages/SellerMapping'
import InfrapayHistoricoVouchers from '../pages/infrapay/historico-vouchers'
import Infrapay from '../pages/infrapay/pages/Infrapay'

import ReportDefaultScreen from '../pages/reports/default'
import UnbilledOrders from '../pages/datatransfer/unbilled-orders'
import TabelasDescricao from '../pages/datatransfer/tabelas-descricao/components/Spreadsheet'
import TimeGap from '../pages/datatransfer/time-gap/TimeGap'
import Multipatrocinadores from '../pages/datatransfer/multipatrocinadores'
import SellerGroup from '../pages/datatransfer/seller-group'

import DevOpsDashboard from '../pages/devops/pages/DashboardPage'
import DevOpsBoard from '../pages/devops/pages/BoardPage'
import DevOpsTeams from '../pages/devops/pages/TeamsPage'
import DevOpsUsers from '../pages/devops/pages/UsersPage'
import DevOpsSprint from '../pages/devops/pages/SprintsPage'
import DevOpsTasks from '../pages/devops/pages/TasksPage'

import RegionalULScreen from '../pages/unilever/regionalul'
import TamanhoULScreen from '../pages/unilever/tamanhoul'

import BriefingPromocoes from '../pages/briefing-promotions/promotions/pages/CreatePromotionPage'
import BriefingAgent from '../pages/briefing-promotions/agent/pages/AgentPage'
import BriefingHistory from '../pages/briefing-promotions/history/pages/HistoryPage'

const PrivateRoutes = () => {
	const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
	return (
		<Routes>
			<Route element={<MasterLayout />}>
				<Route path='auth/*' element={<Navigate to='/home' />} />
				
				<Route path='home' element={<HomePage />} />
				<Route path='/' element={<HomePage />} />
				<Route path='users' element={<Users />} />
				<Route path='companys' element={<CompanyTabs />} />
				
				<Route path='lojas' element={<StoreScreen />} />
				
				<Route path='listas' element={<ListScreen />} />
				<Route path='bus' element={<BUScreen />} />
				<Route path='regionais' element={<RegionalScreen />} />
				<Route path='tamanhos' element={<TamanhoScreen />} />
				<Route path='precos' element={<PriceScreen />} />

				<Route path='cupons' element={<VoucherScreen />} />
				<Route path='apuracao' element={<InvestigationScreen />} />

				<Route path='relatorios/lojistas' element={<ReportLojistas />} />
				<Route path='relatorios/ativacao' element={<ReportAtivacao />} />
				<Route path='relatorios/positivacao' element={<ReportPositivacao />} />
				<Route path='relatorios/cupons' element={<ReportCupons />} />
				<Route path='relatorios/apuracao' element={<ReportApuracao />} />

				<Route path='validacoes/promo_cupom' element={<ValidacaoPromoCupom />} />
				<Route path='validacoes/comparacao_beneficio_valor' element={<ValidacaoComparacaoBeneficioValor />} />
				
				<Route path='api/manage-users' element={<APIManageUsers />} />
				<Route path='api/manage-services' element={<APIManageServices />} />
				<Route path='logs' element={<LogsScreen />} />
				<Route path='alerts' element={<AlertScreen />} />
				<Route path='ai' element={<AIScreen />} />
				<Route path='permissions' element={<PermissionsScreen />} />
				<Route path='settings' element={<SettingsScreen />} />
				
				<Route path='support' element={<SupportWrapper />} />
				<Route path='support/:ticket' element={<SupportWrapper />} />

				<Route path='nps' element={<NPSList />} />
				<Route path='nps/create' element={<NPSCreator npsId={null} onBack={() => {}} />} />
				<Route path='nps/edit/:id' element={<NPSCreator npsId={null} onBack={() => {}} />} />

				<Route path='campaigns' element={<CampaignHistory/>} />

				<Route path='ul-programas' element={<StoreScreen />} />
				<Route path='ul-regionais' element={<RegionalULScreen />} />
				<Route path='ul-tamanhos' element={<TamanhoULScreen />} />
				
				<Route path="conecta/extracao/seller" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaSellers'} title='Relatório - Sellers'/>} />
				<Route path="conecta/extracao/seller-group" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaSellerGroup'} title='Relatório - Sellers Group'/>} />
				<Route path="conecta/extracao/seller-mapping" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaSellerMapping'} title='Relatório - Sellers Mapping'/>} />
				<Route path="conecta/extracao/blocklist-seller" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaBlockListSeller'} title='Relatório - Blacklist Seller'/>} />
				
				<Route path="conecta/extracao/pedidos" element={<ConectaReport options={[
					{name:"Todos", variable:'Tudo', type:'radio', group:'Faturamento', defaultChecked:true },
					{name:"Faturamento Aberto", variable:'Abertos', type:'radio', group:'Faturamento'},
					{name:"Faturamento Fechado", variable:'Fechados', type:'radio', group:'Faturamento'},
					]} showCalendar={true} showDistributor={true} reportMethod={'getConectaPedidos'} title='Relatório - Pedidos' 
					warningMessage='Este relatório tem um tempo maior de processamento, em média 30 minutos. Não atualize a página até a finalização.'/>} 
				/>
				
				<Route path="conecta/extracao/lojista-customer" element={<ConectaReport showCalendar={false} showDistributor={true} showEnvironment={false} reportMethod={'getConectaLojistaCustomer'} title='Relatório - Customer'/>} />
				<Route path="conecta/extracao/lojista-company" element={<ConectaReport showCalendar={false} showDistributor={true} showEnvironment={false} reportMethod={'getConectaLojistaCompany'} title='Relatório - Company '/>} />
				<Route path="conecta/extracao/lojista-ul-nao-ponderadas" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'conecta-extrato-lojista-nao-ul-ponderadas'} title='Relatório - UL Não Ponderadas'/>} />
				<Route path="conecta/extracao/lojista-ul-ponderadas" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaULPonderadas'} title='Relatório - UL Ponderadas'/>} />
				<Route path="conecta/extracao/lojista-vip" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaLojistaVIP'} title='Relatório - Lojista VIP '/>} />
				<Route path="conecta/extracao/grupo-lojista-root" element={<ConectaReport showCalendar={false} showDistributor={false} showEnvironment={false} reportMethod={'getConectaGrupoLojistaRoot'} title='Relatório - Grupo Lojista Root'/>} />
				<Route path="conecta/extracao/grupo-lojista-open" element={<ConectaReport showCalendar={false} showDistributor={false} showEnvironment={false} reportMethod={'getConectaGrupoLojistaOpen'} title='Relatório - Grupo Lojista Open'/>} />
				<Route path="conecta/extracao/lojista-customer-cnpj" element={<ConectaReport hideFilter={true} showCalendar={false} showDistributor={false} showEnvironment={false} inputs={[{label:'CNPJ', variable:'cnpjs', placeholder:'Para informar mais de um CNPJ, utilize vírgula'}]} reportMethod={'conecta-extrato-lojista-customer-cnpj'} title='Relatório - Lojista Customer CNPJ'/>} />
				<Route path="conecta/extracao/lojista-company-cnpj" element={<ConectaReport hideFilter={true} showCalendar={false} showDistributor={false} showEnvironment={false} inputs={[{label:'CNPJ', variable:'cnpjs', placeholder:'Para informar mais de um CNPJ, utilize vírgula'}]} reportMethod={'conecta-extrato-lojista-company-cnpj'} title='Relatório - Lojista Company CNPJ'/>} />
				
				<Route path="conecta/extracao/vendedor" element={<ConectaReport showCalendar={false} showDistributor={true} showEnvironment={false} reportMethod={'getConectaVendedor'} title='Relatório - Vendedor'/>} />
				<Route path="conecta/extracao/grupo-vendedor" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaGrupoVendedor'} title='Relatório - Grupo Vendedor'/>} />
				
				<Route path="conecta/extracao/limite-credito" element={<ConectaReport showCalendar={false} showDistributor={true} showMySQL={true} reportMethod={'getConectaLimiteCredito'} title='Relatório - Limite Crédito'/>} />
				
				<Route path="conecta/extracao/vouchers-primario" element={<ConectaReport showCalendar={false} showDistributor={true} showMySQL={true} reportMethod={'getConectaVoucherPrimario'} title='Relatório - Vouchers Primário'/>} />
				<Route path="conecta/extracao/vouchers-secundario" element={<ConectaReport showCalendar={false} showDistributor={true} showMySQL={true} reportMethod={'getConectaVoucherSecundario'} title='Relatório - Vouchers Secundário'/>} />
				
				<Route path="conecta/extracao/produto" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getConectaProduto'} title='Relatório - Produto'/>} />
				<Route path="conecta/extracao/marca" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getConectaMarcas'} title='Relatório - Marca'/>} />
				<Route path="conecta/extracao/categoria" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getConectaCategorias'} title='Relatório - Categoria'/>} />
				
				<Route path="conecta/extracao/devit-distribuidores" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getDevITDistribuidores'} title='Relatório - DevIT Distribuidores'/>} />
				<Route path="conecta/extracao/devit-lojistas" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getDevITLojistas'} title='Relatório - DevIT Lojistas'/>} />
				<Route path="conecta/extracao/devit-vendedores" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getDevITVendedores'} title='Relatório - DevIT Vendedores'/>} />
				
				<Route path="conecta/extracao/freshdesk-lojista-company" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getFreshdeskLojistaCompany'} title='Relatório - Freshdesk Lojista Company'/>} />
				<Route path="conecta/extracao/freshdesk-lojista-contact" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getFreshdeskLojistaContact'} title='Relatório - Freshdesk Lojista Contact'/>} />
				<Route path="conecta/extracao/freshdesk-vendedor" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getFreshdeskVendedor'} title='Relatório - Freshdesk Vendedor'/>} />
				<Route path="conecta/extracao/freshdesk-distribuidor" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getFreshdeskDistribuidor'} title='Relatório - Freshdesk Distribuidor'/>} />
				
				<Route path="conecta/extracao/industria" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getConectaIndustrias'} title='Relatório - Indústria'/>} />
				<Route path="conecta/extracao/blocklist-industria" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaBlackListIndustria'} title='Relatório - Blocklist Indústria '/>} />
				
				
				
				<Route path="conecta/diferencas/sellers" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasSellers'} title='Relatório - Sellers'/>} />
				<Route path="conecta/diferencas/seller-group" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasSellerGroup'} title='Relatório - Seller Group'/>} />
				<Route path="conecta/diferencas/blocklist-seller" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasBlockListSeller'} title='Relatório - BlackList Seller'/>} />
				<Route path="conecta/diferencas/pedidos" element={<ConectaReport options={[
					{name:"Todos", variable:'Tudo', type:'radio', group:'Faturamento', defaultChecked:true },
					{name:"Faturamento Aberto", variable:'Abertos', type:'radio', group:'Faturamento'},
					{name:"Faturamento Fechado", variable:'Fechados', type:'radio', group:'Faturamento'},
					]} showCalendar={true} showDistributor={true} reportMethod={'getConectaDiferencasPedidos'} title='Relatório - Pedidos'
					warningMessage='Este relatório tem um tempo maior de processamento, em média 30 minutos. Não atualize a página até a finalização.'/>} 
				/>
				
				<Route path="conecta/diferencas/lojista-customer" element={<ConectaReport options={[{name:"Duplicado Email/Telefone", variable:'duplicated'}]} showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasLojistaCustomer'} title='Relatório - Lojista Customer'/>} />
				<Route path="conecta/diferencas/lojista-company" element={<ConectaReport options={[{name:"Duplicado Email/Telefone", variable:'duplicated'}]} showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasLojistaCompany'} title='Relatório - Lojista Company'/>} />
				
				<Route path="conecta/diferencas/vendedores" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasVendedores'} title='Relatório - Vendedores'/>} />
				<Route path="conecta/diferencas/produto" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasProduto'} title='Relatório - Produto'/>} />
				<Route path="conecta/diferencas/marcas" element={<ConectaReport showCalendar={false} showDistributor={true} reportMethod={'getConectaDiferencasMarcas'} title='Relatório - Marca'/>} />
				<Route path="conecta/diferencas/industrias" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getConectaDiferencasIndustrias'} title='Relatório - Indústrias'/>} />
				
				<Route path="conecta/validacao/golive" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getValidacaoGoLive'} title='Relatório de Validação - Go Live'/>} />
				<Route path="conecta/validacao/estoque" element={<ConectaReport showCalendar={false} showDistributor={false} reportMethod={'getValidacaoEstoque'} title='Relatório de Validação - Estoque'/>} />
				<Route path="conecta/validacao/email" element={<ConectaReport showCalendar={false} showDistributor={false} inputs={[{label:'E-mail', variable:'email', placeholder:'Digite um e-mail'}]} reportMethod={'getValidacaoEmail'} title='Relatório de Validação - E-mail'/>} />
				<Route path="conecta/validacao/telefone" element={<ConectaReport showCalendar={false} showDistributor={false} inputs={[{label:'Telefone', variable:'telefone', placeholder:'Digite um telefone', mask:'phone'}]} reportMethod={'getValidacaoTelefone'} title='Relatório de Validação - Telefone'/>} />
				<Route path="conecta/validacao/sellermapping" element={<ConectaReport showCalendar={false} showDistributor={false} inputs={[{label:'CNPJ', variable:'cnpj', placeholder:'Digite um CNPJ', mask:'cnpj'}]} reportMethod={'getValidacaoSellerMapping'} title='Relatório de Validação - Seller Mapping'/>} />
				<Route path="conecta/validacao/cnpjmigrado" element={<ConectaReport showCalendar={false} showDistributor={false} inputs={[{label:'CNPJ', variable:'cnpj', placeholder:'Digite um CNPJ', mask:'cnpj'}]} reportMethod={'getValidacaoCNPJMigrado'} title='Relatório de Validação - CNPJ Migrado'/>} />
				
				
				<Route path="datatransfer/metas-financeiras" element={<DataTransferDefaultScreen/>} />
				<Route path="datatransfer/pedidos-nao-faturados" element={<UnbilledOrders/>} />
				<Route path="datatransfer/tabelas-descricao" element={<TabelasDescricao/>} />
				<Route path="datatransfer/time-gap" element={<TimeGap/>} />
				<Route path="datatransfer/multipatrocinadores" element={<Multipatrocinadores/>} />
				<Route path="datatransfer/seller-group" element={<SellerGroup/>} />
				
				<Route path="seller-mapping" element={<SellerMapping/>} />
				<Route path="infrapay" element={<Infrapay/>} />


				<Route path="reports/pedidos" element={<ReportDefaultScreen report={'pedidos'} title='Relatório - Pedidos'/>} />
				<Route path="reports/cadastro-lojistas" element={<ReportDefaultScreen report={'cadastro_lojistas'} title='Relatório - Cadastro de Lojistas'/>} />
				<Route path="reports/cadastro-vendedores" element={<ReportDefaultScreen report={'vendedor_distribuidor'} title='Relatório - Vendedor e Distribuidor'/>} />
				<Route path="reports/distribuidor-prioritario" element={<ReportDefaultScreen report={'distribuidor_prioritario'} title='Distribuidor Prioritário'/>} />
				<Route path="reports/nota-fiscal" element={<ReportDefaultScreen report={'nota_fiscal'} title='Relatório - Nota Fiscal'/>} />
				<Route path="reports/promocoes" element={<ReportDefaultScreen report={'promocoes'} title='Relatório - Promoções'/>} />
				<Route path="reports/ultimo-preco-estoque" element={<ReportDefaultScreen report={'ultimo_preco_estoque'} title='Relatório - Último Preço Estoque'/>} />
				<Route path="reports/master-interno" element={<ReportDefaultScreen report={'master_interno'} title='Relatório - Master Interno'/>} />
				<Route path="reports/master-produto" element={<ReportDefaultScreen report={'master_produto'} title='Relatório - Master Produto'/>} />
				<Route path="reports/faixa-cep-lojista" element={<ReportDefaultScreen report={'faixa_cep_lojista'} title='Relatório - Faixa de CEP Lojista'/>} />
				
				<Route path="infrapay-report" element={<ReportDefaultScreen report={'infrapay'} title='Relatório - Infrapay'/>} />
				<Route path="infrapay-historico-vouchers" element={<InfrapayHistoricoVouchers/>} />
				
				
				
				
				<Route path="devops/dashboard" element={<DevOpsDashboard/>} />
				<Route path="devops/quadros" element={<DevOpsBoard/>} />
				<Route path="devops/equipes" element={<DevOpsTeams/>} />
				<Route path="devops/usuarios" element={<DevOpsUsers/>} />
				<Route path="devops/sprints" element={<DevOpsSprint/>} />
				<Route path="devops/tarefas" element={<DevOpsTasks/>} />
				
				<Route path="briefing-promocoes/promocoes" element={<BriefingPromocoes/>} />
				<Route path="briefing-promocoes/agente" element={<BriefingAgent/>} />
				<Route path="briefing-promocoes/historico" element={<BriefingHistory/>} />

				<Route
					path='profile/*'
					element={
						<SuspensedView>
						<ProfilePage />
						</SuspensedView>
					}
					/>
				

				<Route path='*' element={<Navigate to='/error/404' />} />
			</Route>
		</Routes>
	)
}

const SuspensedView: FC<WithChildren> = ({children}) => {
	const baseColor = getCSSVariableValue('--kt-primary')
	TopBarProgress.config({
			barColors: {
			'0': baseColor,
		},
		barThickness: 1,
		shadowBlur: 5,
	})
	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
